import React, { FormEventHandler, forwardRef } from 'react';
import { PartialBy } from '@visalex/core';
import { Props } from 'react-phone-number-input';
import ReactPhoneInput from 'react-phone-number-input/mobile';

import cx from 'clsx';
import { Assign } from 'utility-types';

import { Input, InputProps } from '../Input/Input';

import styles from './PhoneInput.module.scss';

const InputComponent = forwardRef<
  HTMLInputElement,
  Assign<InputProps, { onChange: FormEventHandler<HTMLInputElement> }>
>(({ defaultValue: _defaultValue, onChange, className, ...props }, ref) => (
  <Input {...props} className={cx(className, styles['inner-input'])} ref={ref} onChange={(_, e) => onChange(e)} />
));

InputComponent.displayName = 'PhoneInputInner';

export type PhoneInputProps = Omit<PartialBy<Props<InputProps>, 'onChange'>, 'label'>;

/**
 * `PhoneInput` component allows to create an easy to use Phone input with country selector.
 * It inherits all the props from `react-phone-number-input` component and allows to integrate it
 * with `react-hook-form` library using `ref`.
 */
export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ className, defaultCountry = 'US', onCountryChange, onChange, ...props }, ref) => {
    return (
      <ReactPhoneInput
        {...props}
        ref={ref as any}
        onChange={onChange!}
        numberInputProps={props}
        value={props.value || ''}
        inputComponent={InputComponent}
        defaultCountry={defaultCountry}
        onCountryChange={onCountryChange}
        className={cx(className, styles['phone-input'])}
      />
    );
  }
);

PhoneInput.displayName = 'PhoneInput';
